export default __webpack_public_path__ + "static/media/us.0b87c0f8.svg";